import { ReactElement } from 'react';
import PagingTable from '../PagingTable';
/**
 * table of direct reports for selection
 * @param {string} props.headlineText title to display on the table toolbar
 * @param {string} props.name name to identify the component
 * @param {string} props.formik formik context
 * @param {string} props.directReports list of direct reports
 * @param {boolean} props.nonEmployee flag to display non-employee version of table
 * @param {boolean} props.isReview flag to indicate if the table is in review mode
 * @returns {ReactElement} a component to select users
 */
const DirectReportSelect = ({
	headlineText,
	name,
	formik,
	directReports,
	nonEmployee = false,
	isReview = false,
}) => {
	const staff = [
		...directReports.map(dr => ({
			...dr,
			isSelected: formik?.values[name]?.some(x => x?.fiId === dr?.fiId), //conditionally set this based on query params,
		})),
	];

	const defaultHeadCells = [
		{
			id: 'name',
			numeric: false,
			hasHeaderIcon: true,
			label: 'Name',
		},
		{
			id: 'dateValidationExpires',
			numeric: false,
			hasHeaderIcon: false,
			label: 'Status',
		},
		{
			id: 'jobTitle',
			numeric: false,
			hasHeaderIcon: false,
			label: 'Job Title',
		},
		{
			id: 'department',
			numeric: false,
			hasHeaderIcon: false,
			label: 'Department',
		},
	];

	const headCells = [...defaultHeadCells];

	if (nonEmployee) {
		headCells.push({
			id: 'companyName',
			numeric: false,
			hasHeaderIcon: false,
			label: 'Company Name',
		});
	}

	if (isReview && staff.some(s => s.delegatedReviewerName)) {
		headCells.push({
			id: 'delegatedReviewerName',
			numeric: false,
			hasHeaderIcon: false,
			label: 'Delegated Reviewer',
		});
	}

	return (
		<PagingTable
			title={headlineText}
			error={formik.errors[name]}
			initialValues={staff}
			onChange={value => {
				formik.setFieldTouched(name);
				formik.setFieldValue(
					name,
					value.filter(s => s.isSelected),
				);
			}}
			headCells={headCells}
			options={{
				enableSelectAll: true,
				enableCustomSelectAll: true,
				enableKeywordSearch: true,
				singleSelection: false,
			}}
			defaultOrderBy='dateValidationExpires'
			defaultOrder='asc'
			nonEmployee={nonEmployee}
			isReview={isReview && staff.some(s => s.delegatedReviewerName)}
		/>
	);
};

export default DirectReportSelect;
